module.exports = __webpack_public_path__ + "static/media/anc7kz.18bf50fb.pdf";